import type { MailboxInfo } from 'owa-client-types';
import { copilotSettingsStore } from 'owa-copilot-settings-store';
import { isAccountFeatureEnabled } from 'owa-feature-flags';

export function isFrontierPrivateInfluencerUserEnabled(mailboxInfo: MailboxInfo): boolean {
    if (isAccountFeatureEnabled('mon-copilot-dev-frontier', mailboxInfo)) {
        return true;
    }

    const store = copilotSettingsStore(mailboxInfo);
    return (
        store.isFrontierInfluencerUser &&
        isAccountFeatureEnabled('mon-copilot-draft-frontier-private-influencer', mailboxInfo)
    );
}
